import React, { useState } from "react";
import { Form, Input, Button, Space, Select } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

export const InputMultipleSelect = (props) => {
  const { item, form } = props;
  const [selectedValues, setSelectedValues] = useState([]);
  const [inputValues, setInputValues] = useState([]);

  // Function to handle changes in selection
  function onChange(valueId, index) {
    const selectedOption = item.selectData.find((option) => option.id === valueId);
    const allValues = form.getFieldsValue()?.[item?.id] || [];

    // Set the full selected option object in the form state
    allValues[index] = selectedOption;
    form.setFieldsValue({ [item.id]: allValues });
    item['value'] = allValues;

    // Update selectedValues to filter out selected items
    setSelectedValues(allValues.map((option) => option?.id));
  }

  const onInputChange = (index, id) => (event) => {
    const value = event.target.value;

    let updatedInputValues = inputValues;

    if (!updatedInputValues[id]) {
      updatedInputValues[id] = []; // Initialize as an array if it doesn't exist
    }

    updatedInputValues[id][index] = value;
    setInputValues(updatedInputValues);

    if (!item[id]) {
      item[id] = []; // Initialize as an array if it doesn't exist
    }

    item[id] = inputValues[id];
  };

  // Function to handle removal of a field
  function onRemove(index) {
    let allValues = form.getFieldsValue()?.[item?.id] || [];
    allValues.splice(index, 1);
    form.setFieldsValue({ [item.id]: allValues });

    setSelectedValues(allValues.map((option) => option.id));
  }

  const filteredOptions = item.selectData.filter(
    (option) => !selectedValues.includes(option.id)
  );

  return (
    <>
      <Form.Item label={item.label}>
        <Form.List name={item?.id}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => (
                <Space
                  key={key}
                  style={{ display: 'flex', marginBottom: 8 }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    label={item.selectLabel || '' }
                    name={name}
                    tooltip={props.tooltip}
                    rules={[{ required: true, message: 'Please select an option' }]}
                  >
                    <Select
                      placeholder="Select an option"
                      style={{ width: 200 }}
                      onChange={(value) => onChange(value, index)}
                      showSearch
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {filteredOptions.map((option) => (
                        <Option key={option.id} value={option.id}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {item.inputs?.map(({id, label}) => {
                    return <Form.Item
                      key={`${id}${index}`}
                      label={label}
                      rules={[]}
                    >
                      <Input placeholder={label} onChange={onInputChange(index, id)} />
                    </Form.Item>
                  })}
                  <MinusCircleOutlined onClick={() => {
                    remove(name);
                    // onRemove(index);
                  }} />
                </Space>
              ))}
              {((item.limit && fields.length < item.limit) || !item.limit) && 
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    style={{ width: 200 }}
                  >
                    Add field
                  </Button>
                </Form.Item>
              }
            </>
          )}
        </Form.List>
      </Form.Item>
    </>
  );
};
